module.exports = __webpack_public_path__ + "media/images/countrysquared/tn-2ac1ce3e4e73dfccec775368d034901f.svg";